import React, { Component } from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import TeamModalNav from '../team_modal_nav'
import TeamModalSearch from '../team_modal_search'
import TeamMemberList from '../team_member_list'
import TeamInviteList from '../team_invite_list'

class TeamModal extends Component {

    render() {
        const { showTeamModal, toggleTeamModal, team, teamMembers,
            teamInvites=[], reportUser, deleteInvite, createInvite,
            canEditMembership, profile, handleDisableMember, updateMemberRole } = this.props
        const hasInvites = teamInvites.length > 0
        const showInvites = hasInvites && canEditMembership
        return (
            <Modal dialogClassName="team-modal" className="modal-v2 team-manage-modal-container" show={showTeamModal} onHide={toggleTeamModal} animation={false}>
                <Modal.Header closeButton>
                    <TeamModalNav team={team} />
                </Modal.Header>
                <Modal.Body id="modal-body" style={{height: window.innerHeight}}>
                    {canEditMembership && <TeamModalSearch 
                        createInvite={createInvite}
                        team={team}
                        accountName={this.props.accountName}
                        trialEnd={this.props.trialEnd}
                        setPaymentModalOpen={this.props.setPaymentModalOpen}
                        userId={profile.id}
                    />}
                    <TeamMemberList 
                        teamMembers={teamMembers}
                        reportUser={reportUser}
                        canEditMembership={canEditMembership}
                        profile={profile}
                        handleDisableMember={handleDisableMember}
                        updateMemberRole={updateMemberRole}
                        teamOwnerId={team.ownerId}
                    />
                    {showInvites && <div className="team-invite-list-header">
                        <h4>Invited</h4>
                    </div>}
                    {showInvites && <TeamInviteList
                        teamInvites={teamInvites}
                        reportUser={reportUser}
                        deleteInvite={deleteInvite}
                        handleDisableMember={handleDisableMember}
                    />}
                </Modal.Body>
            </Modal>
        )
    }
}

export default TeamModal


// WEBPACK FOOTER //
// ./src/components/modals/team_modal.jsx